import { Injectable } from '@angular/core';
import { ApiService } from '@xref/ngx';
import { map } from 'rxjs/operators';

export class Industry {
  id: number;
  title: string;
  order: number;
}

@Injectable({
  providedIn: 'root'
})
export class IndustriesService {
  constructor(
    private api: ApiService
  ) {}

  industriesRetMapper = (data: any) => data;

  getIndustries() {
    return this.api.get('v1/industry').pipe(map(this.industriesRetMapper));
  }

  getIndustryTitleById(industries: Industry[], id: number) {
    return industries.reduce((acc: any, curr: any) => {
      if (curr.id == id) return curr.title;
      else return acc;
    }, '');
  }
}
